export default {
    s: {
        ringDiameter: 70,
        stickDiameter: 32,
        defaultPosition: {
            x: 145,
            y: 502,
        },
    },
    m: {
        ringDiameter: 98,
        stickDiameter: 45,
        defaultPosition: {
            x: 335,
            y: 844,
        },
    },
    l: {
        ringDiameter: 76,
        stickDiameter: 35,
        defaultPosition: {
            x: 601,
            y: 427,
        },
    },
    xl: {
        ringDiameter: 104,
        stickDiameter: 48,
        defaultPosition: {
            x: 736,
            y: 546,
        },
    },
};
